package meineglasfaser.frontend.admin.pages.auth

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.core.layout.Layout
import io.ktor.client.plugins.*
import io.ktor.http.*
import meineglasfaser.api.routes.AuthRoutes.RealmAdminPortal.Login
import meineglasfaser.frontend.admin.components.AdminUserState
import meineglasfaser.frontend.admin.components.AdminUserStateRedirectIfLoggedIn
import meineglasfaser.frontend.admin.components.GlobalAdminUserState
import meineglasfaser.frontend.common.BackendApi
import meineglasfaser.frontend.common.components.widgets.Toast
import meineglasfaser.frontend.common.components.widgets.Toasts
import meineglasfaser.frontend.common.components.yaform.YaForm
import meineglasfaser.frontend.common.components.yaform.YaFormButton
import meineglasfaser.frontend.common.components.yaform.YaFormTextInput
import meineglasfaser.frontend.common.setJsonBody
import meineglasfaser.frontend.common.withAuth
import org.jetbrains.compose.web.attributes.ButtonType
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.Text

@Page
@Layout(".components.layouts.AdminAuthLayout")
@Composable
fun LoginPage(ctx: PageContext) {
    AdminUserStateRedirectIfLoggedIn()

    Div {
        H1 { Text("Login") }
        YaForm(
            onSubmitScope = { data ->
                val body = Login.RequestBody(
                    user = data.string(Login.RequestBody::user),
                    password = data.string(Login.RequestBody::password),
                )
                BackendApi.post(Login()) {
                    withAuth()
                    setJsonBody(body)
                }.fold(
                    onSuccess = {
                        GlobalAdminUserState.value = AdminUserState.Indeterminate
                        Toasts.display(
                            Toast.success("Erfolgreich angemeldet")
                        )
                        ctx.router.navigateTo("/")
                    },
                    onFailure = { error ->
                        when (error) {
                            is ClientRequestException if error.response.status == HttpStatusCode.BadRequest -> {
                                Toasts.display(
                                    Toast.error("Bitte Benutzer und Passwort angeben")
                                )
                            }
                            is ClientRequestException if error.response.status == HttpStatusCode.Unauthorized -> {
                                Toasts.display(
                                    Toast.error("Benutzer und/oder Passwort falsch")
                                )
                            }
                            else -> {
                                Toasts.display(
                                    Toast.error("Fehler: ${error.message}")
                                )
                            }
                        }
                    }
                )
            },
        ) {
            YaFormTextInput(
                prop = Login.RequestBody::user,
                label = { Text("Benutzer") },
                type = InputType.Text,
                required = true,
            )
            YaFormTextInput(
                prop = Login.RequestBody::password,
                type = InputType.Password,
                label = { Text("Passwort") },
                required = true,
            )
            YaFormButton(
                type = ButtonType.Submit,
            ) {
                Text("Anmelden")
            }
        }
    }
}
